module.exports = __webpack_public_path__ + "img/img_banner_sort02.15cfdef4.svg";